import React from "react";
import { Typography } from "antd";
import PolicyHeader from "../components/PolicyHeader";
import PolicyNav from "../components/PolicyNav";
import { useState, useEffect } from "react";
import _ from "../lib/loadlash";
import { getTermsAndConditions } from "../api/homeApi";

const { Title, Paragraph } = Typography;

const TermsAndConditions = () => {
  const [content, setContent] = useState(null);

  useEffect(() => {
    const fetchContent = async () => {
      const { data, errors } = await getTermsAndConditions();
      if (!_.isEmpty(errors)) {
        console.error("Error fetching terms and conditions:", errors);
        return;
      }
      setContent(data?.data);
    };

    fetchContent();
  }, []);

  const renderBlock = (block, index) => {
    if (block.type === "paragraph") {
      return (
        <Paragraph key={index}>
          {block.children.map((child, i) => (
            <span key={i}>{child.text}</span>
          ))}
        </Paragraph>
      );
    }

    if (block.type === "list") {
      return (
        <ul key={index} style={{ paddingLeft: "2.5rem" }} type="circle">
          {block.children.map((item, idx) => (
            <li key={idx}>
              {item.children.map((child, i) => (
                <span key={i}>{child.text}</span>
              ))}
            </li>
          ))}
        </ul>
      );
    }

    return null;
  };

  return (
    <div className="policy-background wave-container">
      <PolicyHeader heading="Terms and Conditions" />

      <div className="policy-main-div">
        <PolicyNav active="terms" />

        {content?.TextSection?.map((section, index) => (
          <div key={section.id}>
            <Title level={5}>{section.Title}</Title>
            {section.Content.map(renderBlock)}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TermsAndConditions;
